// src/assets/data/courses/index.js

/* Finanzas personales - ES */
import mod1_1 from "./finanzas-personales/modulo-1";
import mod2_1 from "./finanzas-personales/modulo-2";
import mod3_1 from "./finanzas-personales/modulo-3";
import mod4_1 from "./finanzas-personales/modulo-4";
import mod5_1 from "./finanzas-personales/modulo-5";
import mod6_1 from "./finanzas-personales/modulo-6";
import mod7_1 from "./finanzas-personales/modulo-7";

/* Finanzas personales - PT */
import mod1_pt from "./finanzas-personales/modulo-1-pt";
import mod2_pt from "./finanzas-personales/modulo-2-pt";
import mod3_pt from "./finanzas-personales/modulo-3-pt";
import mod4_pt from "./finanzas-personales/modulo-4-pt";
import mod5_pt from "./finanzas-personales/modulo-5-pt";
import mod6_pt from "./finanzas-personales/modulo-6-pt";
import mod7_pt from "./finanzas-personales/modulo-7-pt";

/* Finanzas personales - EN */
import mod1_en from "./finanzas-personales/modulo-1-en";
import mod2_en from "./finanzas-personales/modulo-2-en";
import mod3_en from "./finanzas-personales/modulo-3-en";
import mod4_en from "./finanzas-personales/modulo-4-en";
import mod5_en from "./finanzas-personales/modulo-5-en";
import mod6_en from "./finanzas-personales/modulo-6-en";
import mod7_en from "./finanzas-personales/modulo-7-en";

/* Cripto blockchain - ES */
import mod1_2 from "./cripto-blockchain/modulo-1";
import mod2_2 from "./cripto-blockchain/modulo-2";
import mod3_2 from "./cripto-blockchain/modulo-3";
import mod4_2 from "./cripto-blockchain/modulo-4";
import mod5_2 from "./cripto-blockchain/modulo-5";
import mod6_2 from "./cripto-blockchain/modulo-6";
import mod7_2 from "./cripto-blockchain/modulo-7";
import mod8_2 from "./cripto-blockchain/modulo-8";
import mod9_2 from "./cripto-blockchain/modulo-9";

/* Cripto blockchain - PT */
import mod1_2pt from "./cripto-blockchain/modulo-1-pt";
import mod2_2pt from "./cripto-blockchain/modulo-2-pt";
import mod3_2pt from "./cripto-blockchain/modulo-3-pt";
import mod4_2pt from "./cripto-blockchain/modulo-4-pt";
import mod5_2pt from "./cripto-blockchain/modulo-5-pt";
import mod6_2pt from "./cripto-blockchain/modulo-6-pt";
import mod7_2pt from "./cripto-blockchain/modulo-7-pt";
import mod8_2pt from "./cripto-blockchain/modulo-8-pt";
import mod9_2pt from "./cripto-blockchain/modulo-9-pt";

/* Cripto blockchain - EN */
import mod1_2en from "./cripto-blockchain/modulo-1-en";
import mod2_2en from "./cripto-blockchain/modulo-2-en";
import mod3_2en from "./cripto-blockchain/modulo-3-en";
import mod4_2en from "./cripto-blockchain/modulo-4-en";
import mod5_2en from "./cripto-blockchain/modulo-5-en";
import mod6_2en from "./cripto-blockchain/modulo-6-en";
import mod7_2en from "./cripto-blockchain/modulo-7-en";
import mod8_2en from "./cripto-blockchain/modulo-8-en";
import mod9_2en from "./cripto-blockchain/modulo-9-en";

export const modulesByCourse = {
  "finanzas-personales": {
    "modulo-1": mod1_1,
    "modulo-1-pt": mod1_pt,
    "modulo-1-en": mod1_en,

    "modulo-2": mod2_1,
    "modulo-2-pt": mod2_pt,
    "modulo-2-en": mod2_en,

    "modulo-3": mod3_1,
    "modulo-3-pt": mod3_pt,
    "modulo-3-en": mod3_en,

    "modulo-4": mod4_1,
    "modulo-4-pt": mod4_pt,
    "modulo-4-en": mod4_en,

    "modulo-5": mod5_1,
    "modulo-5-pt": mod5_pt,
    "modulo-5-en": mod5_en,

    "modulo-6": mod6_1,
    "modulo-6-pt": mod6_pt,
    "modulo-6-en": mod6_en,

    "modulo-7": mod7_1,
    "modulo-7-pt": mod7_pt,
    "modulo-7-en": mod7_en,
  },

  "cripto-blockchain": {
    "modulo-1": mod1_2,
    "modulo-1-pt": mod1_2pt,
    "modulo-1-en": mod1_2en,

    "modulo-2": mod2_2,
    "modulo-2-pt": mod2_2pt,
    "modulo-2-en": mod2_2en,

    "modulo-3": mod3_2,
    "modulo-3-pt": mod3_2pt,
    "modulo-3-en": mod3_2en,

    "modulo-4": mod4_2,
    "modulo-4-pt": mod4_2pt,
    "modulo-4-en": mod4_2en,

    "modulo-5": mod5_2,
    "modulo-5-pt": mod5_2pt,
    "modulo-5-en": mod5_2en,

    "modulo-6": mod6_2,
    "modulo-6-pt": mod6_2pt,
    "modulo-6-en": mod6_2en,

    "modulo-7": mod7_2,
    "modulo-7-pt": mod7_2pt,
    "modulo-7-en": mod7_2en,

    "modulo-8": mod8_2,
    "modulo-8-pt": mod8_2pt,
    "modulo-8-en": mod8_2en,

    "modulo-9": mod9_2,
    "modulo-9-pt": mod9_2pt,
    "modulo-9-en": mod9_2en,
  },
};
